import accessStore from '../../../services/locations/AccessStore';

export default (angularModule) => {

  angularModule.factory('accountsService', ($http, $q, cacheService, locationsManagerService, groupsService, userManagerService, $cacheFactory) => {

    var failureCount = 0;
    var accountSelectionDetailsPromise = null;

    // TODO: we could move this to a general service to get an expiring cache, which would be nice for cutting duplicate requests
    let getAccountCache = () => {
      const cache = $cacheFactory.get('accountListCache');
      if (!cache) {
        return $cacheFactory('accountListCache', {created: Date.now()});
      } else {
        if (Date.now() - cache.info().created > 5000) {
          cache.destroy();
          return $cacheFactory('accountListCache', {created: Date.now()});
        } else {
          return cache;
        }
      }
    }

    var self = {}; // just initializing this empty so the IDE doesn't complain
    self = {
      lastSelectedAccount: null,
      getAccountEntityDetails(accountId) {
        const locations = locationsManagerService.listLocations(
          accountId,
          null, // query
          true, // locationSummary
          true  // includeChildAccounts
        ).then(resp => resp.data);

        const groups = groupsService.listGroups(accountId);

        const users = userManagerService.listUsers(accountId,
          null, // query
          0, // offset
          100 // limit
        );

        return $q.all({
          locations: locations, groups: groups, users: users
        })
          .then((promises) => {
            var { locations, groups, users } = promises;
            var locs = locations.locations.map(x => {
              var a = x.address;
              var addressParts = _.filter([a.street, a.city, a.state, a.postalCode], y => y).join(', ');
              return x.businessName + ' - ' + addressParts
            });
            var gs = groups.groups.map(x => `${x.groupName} (${x.locationTotal} Locations)`);

            return {
             users: {
               total: users.total,
               list: users.users.map(x => x.username)
             },
             locations: {
               total: locs.length,
               list: locs
             },
             groups: {
               total: gs.length,
               list: gs
             }
          }
        })

      },
      // TODO this method is (or was) doing double duty — It needs to differentiate between read and write for accounts
      // A) has read access to (which basically just any account that the user has entities in, and might change for each tab.
      // For example they're a standard user with access to locations in multiple accounts, and  want to filter by account
      // B) which accounts they can write to, which should only be selectable if they have account permissions to multiple accounts
      // Right now the endpoint is returning just the accounts that they have management access to, or the user's own account
      // so A) is not really addressed. It used to be returning all sub accounts of the users account, if standard, for this purpose
      listAccounts(params) {
        return $http.get('/v5/accounts', {params:params || {}, cache: getAccountCache()}).then(response => response.data);
      },
      accountsForUser(userId) {
        return $http.get('/v5/accounts/forUser/' + encodeURIComponent(userId)).then(response => response.data);
      },
      updateUserAccounts(userId, accountIds) {
        return $http.put(`/v5/users/${encodeURIComponent(userId)}/accounts`, {accounts: accountIds})
      },
      getAccount(accountId) {
        return $http.get('/v5/accounts/' + accountId, {cache: getAccountCache(), params:{shouldDisplaySanitizedData: true}});
      },
      createAccount(accountName, clientAccountId) {
        clientAccountId = clientAccountId && clientAccountId !== "" ? clientAccountId : null
        return $http.post('/v5/accounts', {accountName, clientAccountId}).then(x => {
          accessStore.invalidate()
          return x
        });
      },
      updateAccount(account) {
        account = {...account,clientAccountId:account.clientAccountId && account.clientAccountId !== "" ? account.clientAccountId : null}
        return $http.put('/v5/accounts/' + account.id, account).then(x => {
          accessStore.invalidate()
          return x
        });
      },
      getAccountSelectionDetails() {
        if (!accountSelectionDetailsPromise) {
          accountSelectionDetailsPromise = self.listAccounts().then(function success(resp) {
            var accounts = resp.accounts;
            failureCount = 0;
            return {
              numAccounts: accounts.length,
              selection: "all",
              onlyAccount: resp.accounts.length > 1 ? null : resp.accounts[0].id
            };
          }, function failure() {
            self.accountSelectionDetailsPromise = null;
            if (failureCount++ < 5) {
              return self.getAccountSelectionDetails();
            } else {
              return {};
            }
          });
        }
        return accountSelectionDetailsPromise;
      },
      getSelectedAccountOrElseOnlyAccountOrAll() {
        return this.getAccountSelectionDetails().then(function (details) {
          // this is a little weird, but I was just trying to make an accountId not required for general list filtering
          // if the user has only one account
          // Currently anywhere that handles having more than one account deals with 'all' state correctly,
          // while single accounts do not
          return details.selection === "all" && details.onlyAccount ? details.onlyAccount : details.selection;
        });
      },
      getSelectedAccountOrElseOnlyAccountOrNull () {
        return self.getSelectedAccountOrElseOnlyAccountOrAll().then(function (accountId) {
          return accountId === "all" ? null : accountId;
        });
      },
      getCurrentAccount() {
        return self.getAccountSelectionDetails().then(function(details) {
          return details.selection;
        })
      },
      setCurrentAccount (accountId) {
        accountSelectionDetailsPromise = self.getAccountSelectionDetails().then(function (details) {
          return Object.assign(details, {selection: accountId})
        });
      },
      deleteAccount(account) {
        return $http.delete('/v5/accounts/' + account.id);
      },
      canSeeMultipleAccounts() {
        return self.listAccounts().then((resp) => {
          return resp.accounts.length > 1;
        })
      },
      retrieveCurrentAccountInfo() {
        return $http.get('/v5/currentAccount').then(response => response.data);
      }
    }

    return self;
  });





};
